// extracted by mini-css-extract-plugin
export default {"answer":"Answer_answer__uplC1","chosen":"Answer_chosen__tkbcs","wrong":"Answer_wrong__vMqj-","correct":"Answer_correct__0ZJlb"};